import React from 'react';
import { EnzymeWorkflow } from '../EnzymeWorkflow';
import { AntibodyWorkflow } from '../AntibodyWorkflow';
import { PeptideWorkflow } from '../PeptideWorkflow';
import type { Project } from '../../../shared/lib/supabase';

interface UnifiedChatProps {
  project: Project;
}

export function UnifiedChat({ project }: UnifiedChatProps) {
  return (
    <div className="min-h-full bg-white px-6 py-4">
      {/* OLD PIPELINE DISABLED - Comment out workflow routing to prevent access to old AWS pipeline */}
      {/* Users should use the Odyssey JSON Creator workflow instead */}
      
      {/* {(() => {
        switch (project.workflow_type) {
          case 'enzyme':
            return <EnzymeWorkflow />;
          case 'antibody':
            return <AntibodyWorkflow />;
          case 'peptide':
            return <PeptideWorkflow />;
          default:
            return (
              <div className="flex items-center justify-center h-full text-gray-500">
                <p>Chat not available for this workflow type</p>
              </div>
            );
        }
      })()} */}
      
      <div className="flex items-center justify-center h-full text-center">
        <div className="max-w-md">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Workflow Disabled</h2>
          <p className="text-gray-600 mb-4">
            The old workflow interface has been disabled to prevent expensive pipeline runs.
          </p>
          <p className="text-gray-600">
            Please use <strong>Protein Design (JSON Creator)</strong> from the sidebar for all protein design tasks.
          </p>
        </div>
      </div>
    </div>
  );
}